<template>
  <div class="lxm-contact-contact-log">
    <lxm-table :heads="formTable.heads"
               :rows="formTable.rows"
               :tos="formTable.tos"
               :expandable="true"></lxm-table>
    <lxm-more v-if="state.formfill.hasMore" :loading="loadingFormfill" @click="moreFormfillClicked"></lxm-more>

    <lxm-table :heads="signupTable.heads"
               :rows="signupTable.rows"
               :tos="signupTable.tos"
               :expandable="true"></lxm-table>
    <lxm-more v-if="state.signup.hasMore" :loading="loadingSignup" @click="moreSignupClicked"></lxm-more>

    <lxm-table :heads="cfTable.heads"
               :rows="cfTable.rows"
               :tos="cfTable.tos"
               :expandable="true"></lxm-table>
    <lxm-more v-if="state.donate.hasMore" :loading="loadingDonate" @click="moreDonateClicked"></lxm-more>
  </div>
</template>

<style lang="stylus">
  @import '../../../styles/variables.styl'
  .lxm-contact-contact-log
    .lxm-table.box
      margin-top: spacing !important
  .lxm-contact-contact-log__table-head
    font-size: size-smaller
    strong
      font-weight: normal
      font-size: size-big
      color: brand-primary
</style>

<script>
  import LxmTable from '../../common/LxmTable.vue'
  import LxmMore from '../../common/LxmMore.vue'
  import { numberFormat } from '../../../../utils'
  import * as aTypes from '../../../../store/action-types'
  export default {
    components: {
      LxmTable,
      LxmMore
    },
    computed: {
      loadingFormfill () {
        return this.$store.state.loading[aTypes.CONTACT_GET_CONTACT_FORMFILLS]
      },
      loadingSignup () {
        return this.$store.state.loading[aTypes.CONTACT_GET_CONTACT_SIGNUPS]
      },
      loadingDonate () {
        return this.$store.state.loading[aTypes.CONTACT_GET_CONTACT_DONATES]
      },
      state () {
        return this.$store.state.contact.contact.log
      },
      signupTable () {
        const state = this.state.signup
        return {
          heads: [
            `活动提交：
            <span class="lxm-contact-contact-log__table-head">
              <strong>${state.count}</strong>次
            </span>`,
            { type: 'icon', value: 'v' }
          ],
          rows: state.list.map(s => [
            s.name,
            {
              type: 'text',
              value: s.value,
              style: { color: '#666666' }
            }]),
          tos: state.list.map(s => {
            return {
              path: '/main/activity/feedback-detail',
              query: {
                contactId: this.$route.query.contactId,
                signupId: s.id
              }
            }
          })
        }
      },
      formTable () {
        const state = this.state.formfill
        return {
          heads: [
            `表单提交：
            <span class="lxm-contact-contact-log__table-head">
              <strong>${state.count}</strong>次
            </span>`,
            { type: 'icon', value: 'v' }
          ],
          rows: state.list.map(s => [
            (s.enable_private_form ? `<img style="height: 16px; margin: 0 4px -2px 0" src="` + require('../../../images/main/lock.png') + `">` : '') + s.name,
            {
              type: 'text',
              value: s.value,
              style: { color: '#666666' }
            }]),
          tos: state.list.map(s => {
            return {
              path: '/main/form/feedback-detail',
              query: {
                contactId: this.$route.query.contactId,
                formfillId: s.id
              }
            }
          })
        }
      },
      cfTable () {
        const state = this.state.donate
        return {
          heads: [
            `筹款提交：
            <span class="lxm-contact-contact-log__table-head">
              <strong>${state.count}</strong>次&nbsp;
              共计<strong>￥${numberFormat(state.sum)}</strong>
            <span>`,
            { type: 'icon', value: 'v' }
          ],
          rows: state.list.map(s => [
            s.name,
            {
              type: 'text',
              value: `¥${numberFormat(s.value)}`,
              style: { color: '#666666' }
            }
          ]),
          tos: state.list.map(s => {
            return {
              path: '/main/cf/feedback-detail',
              query: {
                contactId: this.$route.query.contactId,
                donateId: s.id
              }
            }
          })
        }
      }
    },
    mounted () {
      if (this.$store.state.loaded.contact.contact.id.formfill !== this.$route.query.contactId) {
        this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_FORMFILLS, {
          id: this.$route.query.contactId,
          page: 1,
          append: false
        })
      }
      if (this.$store.state.loaded.contact.contact.id.signup !== this.$route.query.contactId) {
        this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_SIGNUPS, {
          id: this.$route.query.contactId,
          page: 1,
          append: false
        })
      }
      if (this.$store.state.loaded.contact.contact.id.donate !== this.$route.query.contactId) {
        this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_DONATES, {
          id: this.$route.query.contactId,
          page: 1,
          append: false
        })
      }
      this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_DONATE_STAT, this.$route.query.contactId)
    },
    methods: {
      moreFormfillClicked () {
        this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_FORMFILLS, {
          id: this.$route.query.contactId,
          page: this.state.formfill.currentPage + 1,
          append: true
        })
      },
      moreSignupClicked () {
        this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_SIGNUPS, {
          id: this.$route.query.contactId,
          page: this.state.signup.currentPage + 1,
          append: true
        })
      },
      moreDonateClicked () {
        this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_DONATES, {
          id: this.$route.query.contactId,
          page: this.state.donate.currentPage + 1,
          append: true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Log.vue?2f98f594